import React, {useState, useEffect, useRef} from 'react';
import BarraNavegacao from "../components/BarraNavegacao";
import LogoWebSai from '../assets/logo.png';
import { MdSearch } from "react-icons/md";
import { BiUser,BiDownload,BiSearch } from "react-icons/bi";
import Select from 'react-select';
import Swal from 'sweetalert2';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';
const ExcelJS = require('exceljs');


export default function Informacoes(){

    const [unidades, setUnidades] = useState([]);
    const [loading, setLoad] = useState(false);
    const [loadingAcompanhamento, setLoadAcompanhamento] = useState(false);
    const [error, setErrors] = useState({});
    const [acompanhamentos, setAcompanhamento] = useState([]);
    const [acompanhamentosFiltro, setAcompanhamentoFiltro] = useState([]);
    const [aviso, setAviso] = useState("d-none");
    const [search, setSearch] = useState("d-none");    
    
    const [inputs, setInputs] = useState({});
    const [selectedOption, setSelectedOption] = useState(null);
    const selectRef = useRef(null);
    
    const [modalTabulacao, setModalTabulacao] = useState(false);
    const [titleModal, setTitleModal] = useState("");

    const [gruposFilter, setGruposFilter] = useState([]);

    const [loadTipoUnidades, setLoadTipoUnidades] = useState(false);
    const [tipounidades, setTipoUnidades] = useState([]);

    const [funcionarios, setFuncionarios] = useState([]);
    const [loadFuncionarios, setLoadFuncionarios] = useState(false);
    const [cursos, setCursos] = useState([]);
    const [loadCursos, setLoadCursos] = useState(false);

    useEffect(()=>{
        consultarTipoUnidades();
    }, []);

    const handledChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values,[name]:value}));
        setAcompanhamento([]);
        setAcompanhamentoFiltro([]);
        setGruposFilter([]);
        if(event.target.name === "tiporelatorio") setSearch("d-none");
    }

    const consultarTipoUnidades = () =>
    {
        setLoadTipoUnidades(true);
        axios.get(process.env.REACT_APP_API + 'TipoUnidades', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            setTipoUnidades(response.data.value);
            setLoadTipoUnidades(false);
        })
    }

    const consultarUnidades = (event) =>
    {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values,[name]:value}));

        setLoad(true);
        axios.get(process.env.REACT_APP_API + 'Unidades/Tipos/'+event.target.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            setLoad(false);
            setUnidades([]);
            if(response.data.statusCode === 400) {
                Swal.fire({
                    title: 'Não foi possível buscar os dados',
                    text: response.data.value.message,
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
                return;
            }
            else {
                response.data.value.forEach((item) => {
                    setUnidades(unidades => [...unidades,{label:item.nomeSimplicado, value:item.unidadeId}]);
                })
            }
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        buscarFuncionarios();
        buscarCursos();
    }

    const buscarFuncionarios = () => {
        if(!inputs.idtipounidade) setErrors(values => ({...values,idtipounidade:"Selecione o tipo de unidade"})); else setErrors(values => ({...values,idtipounidade:""})); 
        if(!selectedOption) setErrors(values => ({...values,unidade:"Selecione a unidade"})); else setErrors(values => ({...values,unidade:""})); 
        if(selectedOption)
        {
            setFuncionarios([]);
            setCursos([]);
            setLoadFuncionarios(true);

            axios.get(process.env.REACT_APP_API + 'Relatorios/NaoRespondidos/Funcionarios/' + selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
            .then(function(response) {
                //console.log(response.data.value)
                if(response.data.statusCode === 200) {      
                    
                    //buscar respondidos
                    axios.get(process.env.REACT_APP_API + 'Relatorios/Respondidos/Funcionarios/' + selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function (response2){
                        if(response2.data.statusCode === 200) {
                            response2.data.value.empregos.forEach((emp) => {
                                let encontrou = response.data.value.empregos.find(r => r.sistemaGrupoId === emp.sistemaGrupoId);
                                if(encontrou){
                                    let indexEncontrou = response.data.value.empregos.indexOf(encontrou);
                                    emp.pessoas.forEach((p) => {
                                        if(encontrou.pessoas.find(p => p.matricula !== p.matricula)){
                                           //adicionar pessoa
                                           response.data.value.empregos[indexEncontrou].pessoas.push(p);
                                        }
                                    })
                                }
                                else {
                                    response.data.value.empregos.push(emp);
                                }
                            })
                        }

                        //contando total de funcionários
                        response.data.value.empregos.forEach((emp, i) => {
                            var total = 0;
                            emp.pessoas.forEach((pess, j) => {
                                total++;
                            })
                            response.data.value.empregos[i].total = total;
                        }) 
                        
                        setFuncionarios(response.data.value);
                        setLoadFuncionarios(false);
                    })
                    
                }
                else {
                    //buscar respondidos
                    axios.get(process.env.REACT_APP_API + 'Relatorios/Respondidos/Funcionarios/' + selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function (response2){
                        if(response2.data.statusCode === 200) {
                            //contando total de funcionários
                            response.data.value.empregos.forEach((emp, i) => {
                                var total = 0;
                                emp.pessoas.forEach((pess, j) => {
                                    total++;
                                })
                                response.data.value.empregos[i].total = total;
                            }) 
                            
                            setFuncionarios(response.data.value);
                            setAviso("d-none");
                        }
                    })
                    setLoadFuncionarios(false);
                }
            })
        }
    }

    const buscarCursos = () => {
        if(!inputs.idtipounidade) setErrors(values => ({...values,idtipounidade:"Selecione o tipo de unidade"})); else setErrors(values => ({...values,idtipounidade:""})); 
        if(!selectedOption) setErrors(values => ({...values,unidade:"Selecione a unidade"})); else setErrors(values => ({...values,unidade:""})); 
        if(selectedOption)
        {
            setLoadCursos(true);
            let dados = {unidadeId: selectedOption.value};
            axios.post(process.env.REACT_APP_API + 'CursosUnidades/Simplificado/Generico',dados, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
            .then(function(response) {
                if(response.data.statusCode === 200) {   
                    
                    //buscar Alunos
                   /* let alunos = [];
                    axios.get(process.env.REACT_APP_API + 'Relatorios/NaoRespondidos/Alunos/'+selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function(response) {
                        if(response.data.statusCode === 200) {   
                            aluno = response.data.value;
                        }
                    });

                    axios.get(process.env.REACT_APP_API + 'Relatorios/Respondidos/Alunos/'+selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function(response) {
                        if(response.data.statusCode === 200) {   
                            aluno = response.data.value;
                        }
                    });*/
                    
                    setCursos(response.data.value);
                }
                setLoadCursos(false);
            })
        }
    }

    const controlModalTabulacao = (state,sistemaGrupoId,descricao) => {
        setModalTabulacao(state);
        if(state && typeof acompanhamentos !== "undefined") //state
        {
            setTitleModal(descricao);
            inputs.tiporelatorio === "frespondidos" || inputs.tiporelatorio === "fnaorespondidos"  ?
                acompanhamentos.empregos.forEach((item) => {
                    if(item.sistemaGrupoId === sistemaGrupoId) {
                        setAcompanhamentoFiltro(item.pessoas);
                        return;
                    }
                })
            : //alunos
            acompanhamentos.forEach((item) => {
                if(item.cursoId === sistemaGrupoId) {
                    setAcompanhamentoFiltro(item);
                    return;
                }
            })
        }
    }

    const exportExcel = () => {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'WebSai';
        //workbook.lastModifiedBy = 'Bot';
        workbook.created = new Date();
        workbook.modified = new Date();
        workbook.lastPrinted = new Date();

        if(inputs.tiporelatorio === 'frespondidos' || inputs.tiporelatorio === 'fnaorespondidos') {
            const sheet = workbook.addWorksheet('Funcionarios');
            sheet.columns = [
                { header: 'Matrícula', key: 'matricula', width: 20 },
                { header: 'Nome', key: 'nome', width: 40},
                { header: 'E-mail', key: 'email', width: 40},
                { header: 'Situação', key: 'situacao', width: 20 }
            ];

            acompanhamentosFiltro.forEach((pa, key) =>
            sheet.addRow({
                matricula: pa.matricula,
                nome: pa.nome,
                email: pa.email,
                situacao:pa.situacao
            })
            );
        }
        else {
            const sheet = workbook.addWorksheet('Alunos');
            sheet.columns = [
                { key: 'matricula', width: 20 },
                { key: 'nome', width: 40},
                { key: 'email', width: 40},
                { key: 'situacao', width: 20 }
            ];

            acompanhamentosFiltro.periodos.forEach((per) => {

                per.anoSemestres.forEach((sem) => {
                    sheet.addRow({
                        matricula: sem.anoSemestre + ' ' + acompanhamentosFiltro.curso + ' (' +per.periodo + ')'
                    });

                    sheet.addRow({
                        matricula: 'Matrícula',
                        nome: 'Nome',
                        email: 'E-mail',
                        status: 'Situação'
                    })

                    sem.pessoas.forEach((aluno) => {
                        sheet.addRow({
                            matricula: aluno.matricula,
                            nome: aluno.nome,
                            email: aluno.email,
                            situacao:aluno.situacao
                        })
                    })

                    sheet.addRow({
                        matricula: ''
                    });

                })

            })
        }

        workbook.xlsx.writeBuffer().then(data => {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheet.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = 'download.xlsx';
            anchor.click();
            window.URL.revokeObjectURL(url);
        })
    }

    const searchGrupos = (event) => {
        if(inputs.tiporelatorio === 'frespondidos' || inputs.tiporelatorio === 'fnaorespondidos') {
            var updatedList = [...acompanhamentos.empregos];
            const filtered = updatedList.filter(item => {
                return item.sistemaGrupo.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
            });
            setGruposFilter(filtered);
        }
        else
        {
            updatedList = [...acompanhamentos];
            const filtered = updatedList.filter(item => {
                return item.curso.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
            });
            setGruposFilter(filtered);
        }
    }
    

    return (
        <div> 
            <BarraNavegacao/>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-12">
                        <div className="background rounded p-3">
                            <div className="text-center mb-2">
                                <img src={LogoWebSai} alt="Logo" style={{width:150}}/>
                            </div>
                            <p className="text-center fw-bold fs-5 mb-0">INFORMAÇÕES DA UNIDADE</p>
                            <p className="text-center">Visualize informações de cursos, funcionários e alunos referente a uma unidade específica.</p>
                            <hr/>
                            <div className="bg-white rounded p-3 border mb-2">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="mb-2 col-sm-4">
                                            <label htmlFor="tiporelatorio">Tipo de Unidade</label>
                                            <select className="form-control" name="idtipounidade" onChange={consultarUnidades}>
                                                <option value={""}>{loadTipoUnidades ? 'Carregando...':'Selecione...'}</option>
                                                {
                                                    tipounidades.map((tipos, key) => 
                                                        <option value={tipos.tipoUnidadeId}>{tipos.descricao}</option>
                                                    )
                                                }
                                            </select>
                                            <span className="text-danger">{error.idtipounidade}</span>
                                        </div>
                                        <div className="mb-2 col-sm-8">
                                            <label htmlFor="idunidade">Selecione a unidade</label>
                                            <Select
                                                options={unidades}
                                                onChange={setSelectedOption}
                                                placeholder={loading ? "Carregando..." : "Selecione..."}
                                                ref={selectRef}
                                            />
                                            <span className="text-danger">{error.unidade}</span>
                                        </div>
                                    </div>
                                    <div className="d-grid gap-2 col-sm-4 mx-auto">
                                        <button type="submit" className="btn btn-custom mt-2">
                                            <MdSearch/> {loadFuncionarios || loadCursos ? "Carregando... " : "Pesquisar "}
                                            <RotatingLines
                                                strokeColor="white"
                                                strokeWidth="5"
                                                animationDuration="0.75"
                                                width="20"
                                                visible={loadFuncionarios || loadCursos ? true : false}
                                            />
                                            </button>
                                    </div>
                                </form>  
                            </div>

                            <div className={loadFuncionarios || loadCursos ? "d-none":"row mt-3"}>
                                <div className="col-md-12">
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Servidores</Accordion.Header>
                                            <Accordion.Body>
                                                <div className={typeof funcionarios.empregos !== "undefined" ? 'd-none':'alert alert-warning'}>
                                                    Não foram encontrados resultados
                                                </div>
                                                <table className="table">
                                                    <tbody>
                                                        {
                                                            typeof funcionarios.empregos !== "undefined" ?
                                                            funcionarios.empregos.map((func) => 
                                                            <tr>
                                                                <td><span class="badge rounded-pill bg-danger">{func.total}</span> {func.sistemaGrupo}</td>
                                                                <td>
                                                                    <div className='text-center'>
                                                                        <button className='btn btn-secondary btn-sm'>Visualizar</button>
                                                                    </div>
                                                                    
                                                                </td>
                                                            </tr>
                                                            ):null 
                                                        }
                                                    </tbody>
                                                </table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>Cursos / Alunos</Accordion.Header>
                                            <Accordion.Body>
                                                <div className={typeof cursos !== "undefined" ? 'd-none':'alert alert-warning'}>
                                                    Não foram encontrados resultados
                                                </div>
                                                <table className="table">
                                                    <tbody>
                                                        {
                                                            typeof cursos !== "undefined" ?
                                                            cursos.map((c) => 
                                                            <tr>
                                                                <td><span class="badge rounded-pill bg-danger">0</span> {c.curso.nomeCompleto} ({c.curso.tipoCurso})</td>
                                                                <td>
                                                                    <div className='text-center'>
                                                                        <button className='btn btn-secondary btn-sm'>Visualizar Alunos</button>
                                                                    </div>
                                                                    
                                                                </td>
                                                            </tr>
                                                            ):null 
                                                        }
                                                    </tbody>
                                                </table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>

                                </div>

                            </div>
                            

                            <hr/>
                            <div className="text-center mt-3">
                                <svg viewBox="0 0 1000 656.5" style={{width:70}}>
                                    <title>Centro Paula Souza</title>
                                    <path fill="#af0916" d="M760 181.2c.8-23.8 11.1-33.3 45.2-33.3H993V81.4H817c-83.2 0-130 35.6-130 103 0 131.5 240.1 104.6 240.1 174.3 0 23.8-12.7 36.5-45.2 36.5H636.3c24.8-30.3 40-69.4 40-114.1 0-112.5-72.9-207.5-196.4-207.5-111.7 0-191.7 84-191.7 209.1v31.1h-84.6c-65.7 0-130.7-42.8-130.7-123.6s65-123.6 130.7-123.6h53.9V0H191C102.2 0 0 68.1 0 190.1s102.2 190.1 190.9 190.1h97.3v276.2h69.7V380.2h132.7v-66.5H357.9v-18.4c0-104.6 55.5-155.3 122-155.3 74.5 0 126.7 54.6 126.7 132.3 0 66.7-36.1 110-93.3 122.8h-88.9v66.5H882c67.3 0 118-34.1 118-106.1 0-136.3-240.9-108.5-240-174.3" class="icon"></path>
                                    <path d="M481.6 560.8c-3.7 1.7-11.2 3.3-20.8 3.3-22.2 0-38.9-12.5-38.9-35.6 0-22 16.7-37 41.1-37 9.8 0 16 1.9 18.7 3.1l-2.4 7.4c-3.9-1.7-9.4-2.9-15.9-2.9-18.4 0-30.7 10.5-30.7 29 0 17.2 11.1 28.3 30.2 28.3 6.2 0 12.5-1.1 16.6-2.9l2.1 7.3zm16.8-21.2c.2 12.4 9.1 17.5 19.4 17.5 7.4 0 11.8-1.2 15.6-2.6l1.8 6.5c-3.6 1.5-9.8 3.1-18.8 3.1-17.4 0-27.8-10.2-27.8-25.5 0-15.2 10-27.2 26.5-27.2 18.4 0 23.3 14.5 23.3 23.8 0 1.9-.2 3.3-.4 4.3h-39.6zm30.1-6.6c.1-5.8-2.7-14.9-14.2-14.9-10.4 0-14.9 8.5-15.8 14.9h30zm22.6-6.7c0-5.2-.1-9.5-.5-13.7h9.1l.6 8.3h.2c2.8-4.8 9.3-9.5 18.7-9.5 7.8 0 20 4.2 20 21.5v30.2H589V534c0-8.1-3.4-14.9-13.1-14.9-6.8 0-12 4.3-13.8 9.4-.4 1.1-.7 2.7-.7 4.3v30.4h-10.3v-36.9zm76.8-28.2v14.5h14.7v7h-14.7v27.3c0 6.2 2 9.8 7.7 9.8 2.7 0 4.7-.3 6-.6l.5 6.9c-2 .7-5.1 1.3-9.1 1.3-4.8 0-8.6-1.4-11.1-3.9-2.9-2.7-4-7.2-4-13.1v-27.6h-8.8v-7h8.8v-12.1l10-2.5zm26.2 30.3c0-6-.1-11-.5-15.8h9l.3 9.9h.5c2.6-6.8 8.7-11.1 15.6-11.1 1.2 0 2 .1 2.9.3v8.6c-1-.2-2.1-.3-3.5-.3-7.2 0-12.4 4.9-13.8 11.8-.2 1.3-.5 2.7-.5 4.3V563h-10.2v-34.6zm88.2 9.1c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.5 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.1 19.4 9.8 0 17.2-8.2 17.2-19.6 0-8.6-4.8-19.4-16.9-19.4-12.2 0-17.4 10-17.4 19.6m-270.9 47.3c4.9-.7 11.3-1.4 19.5-1.4 10 0 17.4 2.1 22.1 5.9 4.3 3.3 6.9 8.5 6.9 14.7 0 6.4-2.1 11.4-6.1 15-5.4 5.1-14.1 7.7-24 7.7-3 0-5.9-.1-8.2-.6v28.2h-10.2v-69.5zm10.1 33.9c2.2.5 5 .7 8.4.7 12.3 0 19.7-5.3 19.7-15 0-9.3-7.4-13.8-18.6-13.8-4.4 0-7.8.3-9.6.7v27.4zm79.9 35.6l-.8-6.4h-.3c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.4-6.1c4.7-2.7 11.5-4.5 18.5-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.3zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629zm73.8 12c0 5.2.1 9.8.4 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm17-60.3h10.3v74.1h-10.3zm58.9 74.1l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-24 1.6-24 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.3-1 .6-2 .6-2.9V629zm50.2 14.7c4.5 2.5 11.2 4.6 18.2 4.6 10.4 0 16.5-4.9 16.5-12 0-6.6-4.2-10.3-14.8-14-12.9-4.1-20.8-10-20.8-19.9 0-11 10.1-19.1 25.4-19.1 8 0 13.9 1.7 17.4 3.4l-2.8 7.4c-2.6-1.2-7.8-3.3-15-3.3-10.7 0-14.8 5.7-14.8 10.5 0 6.6 4.8 9.8 15.7 13.6 13.3 4.6 20.1 10.3 20.1 20.7 0 10.9-9 20.2-27.6 20.2-7.6 0-15.9-2-20.1-4.5l2.6-7.6zm110.4-14.6c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.6 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.2 19.4 9.8 0 17.2-8.3 17.2-19.6 0-8.5-4.8-19.4-16.9-19.4-12.3 0-17.5 10-17.5 19.6m105 11.4c0 5.2.1 9.8.5 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm10.7 8.5l25.6-29.8c2.4-2.7 4.8-5.1 7.3-7.8v-.2h-30.6v-7.4h43.1l-.1 5.8-25.2 29.3c-2.3 2.8-4.6 5.3-7.2 7.9v.2h33v7.3h-45.9v-5.3zm87.6 5.3l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.5 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629z" class="title"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal size="xl" show={modalTabulacao} onHide={() => controlModalTabulacao(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{titleModal}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <button type="button" className="btn btn-custom btn-sm  mb-2" onClick={exportExcel}><BiDownload/> Download</button>
                    {
                        <div className="table-responsive col-12">
                            <table className="table table-striped">
                                <tbody>
                                    {
                                        typeof acompanhamentosFiltro !== "undefined" ?
                                        acompanhamentosFiltro.map((pa, key) =>
                                            <tr>
                                                <td>{pa.matricula}</td>
                                                <td>{pa.nome}</td>
                                                <td>{pa.email}</td>
                                                <td className="text-center"><span className={pa.situacao === "Participação Finalizada" ? "text-success" : "text-danger"}>{pa.situacao}</span></td>
                                            </tr>
                                        ) : null
                                    }
                                </tbody>
                            </table>
                        </div>             
                    }
                </Modal.Body>
            </Modal>

        </div>
    )
}